import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  TextField,
  Typography,
} from "@mui/material/";
import React from "react";
import { t } from "ttag";
import useStyles from "./Firmware.style";

interface EditFirmwareVersionDialogProps {
  open: boolean;
  editVersion: any;
  onClose: () => void;
  onChange: (event: any) => void;
  onStableChange: (checked: boolean) => void;
  onSubmit: () => void;
}

const EditFirmwareVersionDialog = ({
  open,
  editVersion,
  onClose,
  onChange,
  onStableChange,
  onSubmit,
}: EditFirmwareVersionDialogProps) => {
  const styles: any = useStyles();
  const releaseNotesText = editVersion.releaseNotesText || "";

  return (
    <Dialog
      onClose={onClose}
      open={open}
      classes={{ paper: styles.dialogPaper, container: styles.dialogContainer }}
    >
      <DialogTitle id="simple-dialog-title">{t`Edit Firmware Version`}</DialogTitle>
      <DialogContent className={styles.dialogContent}>
        <TextField
          label={t`Version`}
          id={"version"}
          className={styles.inputField}
          variant={"standard"}
          onChange={onChange}
          value={editVersion.version || ""}
        />
        <TextField
          label={t`Build Date`}
          id={"buildDate"}
          type="date"
          InputLabelProps={{ shrink: true }}
          className={styles.inputField}
          variant={"standard"}
          onChange={onChange}
          value={editVersion.buildDate ? editVersion.buildDate.slice(0, 10) : ""}
        />
        <FormControlLabel
          control={
            <Checkbox
              id={"isStable"}
              checked={!!editVersion.isStable}
              onChange={(event: any) => onStableChange(event.target.checked)}
            />
          }
          label={t`Stable`}
        />
        <TextField
          label={t`Release notes`}
          id={"releaseNotesText"}
          className={styles.releaseNotesField}
          variant={"outlined"}
          multiline
          fullWidth
          onChange={onChange}
          value={releaseNotesText}
          placeholder={t`Markdown supported (e.g. **bold**, lists, links)`}
          helperText={
            <Typography component="span" variant="caption" color="textSecondary">
              {t`Markdown format`}
            </Typography>
          }
        />
      </DialogContent>
      <DialogActions>
        <Button className={styles.sharedButtonStyle} onClick={onClose}>
          {t`Cancel`}
        </Button>
        <Button
          onClick={onSubmit}
          className={`${styles.sharedButtonStyle} ${styles.submitButton}`}
        >
          {t`Update`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditFirmwareVersionDialog;
